import React from "react";
import { useAppSelector } from "../../redux/configureStore";
import Alert from "./Alert";
import Confirmation from "./Confirmation";
import { getAlerts, getIncompleteConfirmations } from "../app/selectors";

const Modals = () => {
  const alerts = useAppSelector(getAlerts);
  const confirmations = useAppSelector(getIncompleteConfirmations);

  if (alerts.length > 0) {
    return <Alert alert={alerts[0]} />;
  }

  if (confirmations.length > 0) {
    return <Confirmation confirmation={confirmations[0]} />;
  }

  return (
    <div>
      <style jsx>{`
        div {
          position: absolute;
          width: 100%;
          height: 100%;
          pointer-events: none;
        }
      `}</style>
    </div>
  );
};

export default Modals;
